import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import useCurrentUser from '../hooks/useCurrentUser';

const InlineManual = () => {
  const currentUser = useCurrentUser();
  const location = useLocation();
  const hasBooted = useRef(false);
  const bootTimeout = useRef(null);

  useEffect(() => {
    const userId = currentUser?.id || currentUser?.userId || currentUser?.user_id || currentUser?.uniqueId;
    const tenantId = currentUser?.tenantId;
    const createdAt = currentUser?.createdAt;
    const updatedAt = currentUser?.updatedAt;
    
    if (window.InlineManual && 
      currentUser && 
      userId && 
      tenantId && 
      createdAt && 
      updatedAt && 
      !hasBooted.current) 
    {
      try {
        if (bootTimeout.current) {
          clearTimeout(bootTimeout.current);
        }
        
        bootTimeout.current = setTimeout(() => {
          try {
            window.InlineManual("boot", { "uid": userId.toString(), 
              "tenantname": tenantId.toString(), 
              "created": createdAt, 
              "updated": updatedAt });
            hasBooted.current = true;
          } catch (error) {
            console.error('Error initializing Inline Manual:', error);
          }
        }, 300);
        
      } catch (error) {
        console.error('Error setting up Inline Manual boot:', error);
      }
    }
    
    if (!currentUser && hasBooted.current) {
      hasBooted.current = false;
      
      if (bootTimeout.current) {
        clearTimeout(bootTimeout.current);
        bootTimeout.current = null;
      }
      
      if (window.InlineManual) {
        try {
          window.InlineManual("shutdown");
          
          setTimeout(() => {
            const persistentElements = document.querySelectorAll(
              '[id*="inline-manual"], [class*="inline-manual"], [class*="inlinemanual"], ' +
              '.im-widget, .im-help-widget, [data-inline-manual], ' +
              '[class*="im-"], [id*="im-"], [class*="help"]'
            );
            
            persistentElements.forEach(element => {
              const elementText = element.textContent?.toLowerCase() || '';
              const elementClass = element.className?.toLowerCase() || '';
              const elementId = element.id?.toLowerCase() || '';
              
              if (elementText.includes('help') || elementClass.includes('inline') || 
                  elementClass.includes('manual') || elementId.includes('inline') ||
                  elementClass.includes('im-') || elementId.includes('im-')) {
                element.remove();
              }
            });
          }, 100);
          
        } catch (error) {
          console.error('Error shutting down Inline Manual in component:', error);
        }
      }
    }
    
    return () => {
      if (bootTimeout.current) {
        clearTimeout(bootTimeout.current);
        bootTimeout.current = null;
      }
    };
  }, [currentUser]);

  useEffect(() => {
    if (window.InlineManual && currentUser && hasBooted.current) {
      const updateTimeout = setTimeout(() => {
        try {
          window.InlineManual("update");
        } catch (error) {
          console.error('Error updating Inline Manual:', error);
        }
      }, 100);
      
      return () => clearTimeout(updateTimeout);
    }
  }, [location, currentUser]);

  return null;
};

export default InlineManual;
